let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("byLpQ")).then(() => parcelRequire('59j1T'));